import { createContext, useState, useContext, ReactNode, FC, useEffect } from "react";
import { LanguageContextType } from "../Types/types";

const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: FC<LanguageProviderProps> = ({ children }) => {
  // Initialize language from localStorage or default to "en"
  const getInitialLanguage = () => {
    if (typeof window !== 'undefined') {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        return storedLanguage;
      }
      // Optional: detect browser language as fallback
      const browserLanguage = navigator.language.split('-')[0];
      // You could add a list of supported languages and check if browserLanguage is supported
      const supportedLanguages = ['en', 'de', 'fr', 'es', 'ar', 'cz', 'hu', 'nl', 'pl', 'ru', 'sk', 'sv', 'no', 'da', 'fi'];
      if (supportedLanguages.includes(browserLanguage)) {
        return browserLanguage;
      }
    }
    return "en";
  };

  const [language, setLanguage] = useState<string>(getInitialLanguage);

  // Save language to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
